import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PRIVACY_VERSION, LEGAL_EFFECTIVE_DATE, PRIVACY_EMAIL } from '../../lib/legal';
import './Legal.css';

function PrivacyPolicy() {
  const navigate = useNavigate();
  return (
    <div className="legal-page">
      <header className="legal-header">
        <button className="legal-back" onClick={() => navigate(-1)} aria-label="Indietro">←</button>
        <h1>Informativa Privacy</h1>
      </header>
      <div className="legal-body">
        <p className="legal-meta">Versione {PRIVACY_VERSION} · In vigore dal {LEGAL_EFFECTIVE_DATE}</p>

        <h2>Titolare del trattamento</h2>
        <p>
          Simone Moreno, persona fisica — Corso Dante 117, interno 3, 16043 Chiavari (GE), Italia.
          C.F. MRNSNN98D11D969K — P.IVA 02715000994. Nessun DPO nominato.
          Contatti per privacy ed esercizio dei diritti: <strong>{PRIVACY_EMAIL}</strong>.
        </p>

        <h2>1. Dati trattati</h2>
        <ul>
          <li><strong>Dati account</strong>: nome, email, password (conservata cifrata), username; immagine profilo (avatar generato, nessun caricamento di foto).</li>
          <li><strong>Dati di allenamento e performance</strong>: esercizi, serie, ripetizioni, carico sollevato, durata, velocità, inclinazione, distanza, schede, progressi, XP, badge, livello.</li>
          <li><strong>Contenuti a testo libero</strong>: biografia del profilo, note di allenamento ed esercizio, descrizioni di programmi, richieste di nuovi esercizi.</li>
          <li><strong>Dati community</strong>: follow, profilo pubblico (solo se attivato dall'utente).</li>
          <li><strong>Dati tecnici</strong>: registri di errore (senza dati identificativi), dati per le notifiche push.</li>
        </ul>

        <h2>2. Natura dei dati e dati relativi alla salute</h2>
        <p>
          Le metriche di allenamento (carico, ripetizioni, velocità, distanza) sono <strong>dati di performance</strong> e
          non costituiscono dati relativi alla salute. Uptra non richiede né è progettata per raccogliere dati sanitari o
          categorie particolari (art. 9 GDPR). I campi a testo libero <strong>non devono essere utilizzati</strong> per
          inserire diagnosi, infortuni, patologie o altre informazioni mediche. Qualora un utente inserisca comunque tali
          informazioni, Uptra può, ove necessario, limitarne l'uso, rimuoverle o richiedere un consenso specifico e
          ulteriori istruzioni. Un consenso esplicito e separato sarà richiesto solo per eventuali future funzioni
          progettate per raccogliere dati relativi alla salute.
        </p>

        <h2>3. Finalità e basi giuridiche</h2>
        <ul>
          <li>Erogazione del servizio, gestione account, schede, allenamenti e community → <strong>esecuzione del contratto</strong> (art. 6.1.b).</li>
          <li>Sicurezza, diagnostica errori e prevenzione abusi → <strong>legittimo interesse</strong> (art. 6.1.f).</li>
          <li>Adempimenti di legge → <strong>obbligo legale</strong> (art. 6.1.c).</li>
          <li>Eventuali dati relativi alla salute (solo funzioni future dedicate) → <strong>consenso esplicito</strong> (art. 9.2.a), separato e versionato.</li>
        </ul>

        <h2>4. Responsabili esterni e destinatari</h2>
        <p>Fornitori che trattano dati per conto del Titolare (nominati responsabili ex art. 28):</p>
        <ul>
          <li><strong>Supabase</strong> — database, autenticazione, hosting dati (UE).</li>
          <li><strong>Vercel</strong> — hosting dell'applicazione.</li>
          <li><strong>Resend</strong> — invio email transazionali (UE).</li>
          <li><strong>Sentry</strong> — monitoraggio errori, configurato senza dati identificativi.</li>
        </ul>

        <h2>5. Trasferimenti extra-UE</h2>
        <p>Ove alcuni fornitori comportino trasferimenti fuori dall'Unione Europea, il trattamento avviene sulla base di adeguate garanzie (es. Clausole Contrattuali Standard).</p>

        <h2>6. Conservazione</h2>
        <p>
          I dati sono conservati finché l'account è attivo. Alla cancellazione dell'account, i dati personali sono rimossi
          immediatamente e in modo definitivo dai sistemi in produzione. Eventuali copie nei backup tecnici possono
          persistere fino alla loro naturale scadenza (indicativamente ~7 giorni), dopodiché sono eliminate. I contributi
          al catalogo esercizi vengono anonimizzati.
        </p>

        <h2>7. Diritti dell'interessato</h2>
        <p>
          Accesso, rettifica, cancellazione (disponibile in autonomia dall'app, oltre che su richiesta), limitazione,
          portabilità, opposizione. È possibile proporre reclamo al Garante per la protezione dei dati personali. Per
          esercitare i diritti: <strong>{PRIVACY_EMAIL}</strong>.
        </p>

        <h2>8. Sicurezza</h2>
        <p>Trasmissione cifrata (HTTPS), cifratura dei dati a riposo, controllo degli accessi a livello di riga (RLS), accesso amministrativo ristretto.</p>

        <h2>9. Cookie e tecnologie</h2>
        <p>Uptra utilizza esclusivamente strumenti tecnici e necessari al funzionamento e il monitoraggio degli errori. Non sono utilizzati strumenti di analytics o cookie di marketing.</p>

        <h2>10. Minori</h2>
        <p>Il servizio è riservato a chi ha almeno 14 anni.</p>

        <h2>11. Modifiche</h2>
        <p>La presente informativa è versionata; le modifiche sostanziali saranno comunicate e, ove richiesto dalla legge, sarà raccolto un nuovo consenso per i trattamenti che lo richiedono.</p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
